<template>
  <b-modal
    id="first-connexion-modal"
    :ref="reference"
    :cancel-title="cancelButtonTitle"
    :header-class="{'first-connexion-header': this.currentStep === 4}"
    :ok-title="okButtonTitle"
    centered
    class="first-connexion-full-screen-modal"
    no-close-on-backdrop
    no-close-on-esc
    ok-variant="primary"
    @hidden="resetModal"
    @ok="handleOk">

    <template #modal-header="{ close }">
      <div v-if="(currentStep<4||currentStep>=5)" class="first-connexion-header-content w-100">
        <div class="first-connexion-bg-veilleur h-75"></div>
        <img v-if="currentStep===1" :src="require(`@/assets/images/b122/ic_investigator_miror.png`)"
             class="first-connexion-step-img">
        <img v-if="currentStep===2" :src="require(`@/assets/images/b122/img-watcher-right.png`)"
             class="first-connexion-step-img">
        <img v-if="currentStep===3" :src="require(`@/assets/images/b122/ic_investigator_gifts.png`)"
             class="first-connexion-step-img">
        <img v-if="currentStep>=5" :src="require(`@/assets/images/b122/img-watcher-right.png`)"
             class="first-connexion-step-img">
      </div>
      <div v-if="currentStep===4" class="first-connexion-header-content step4 w-100">
        <div class="first-connexion-container h-100">
          <h1 class="page-title ml-4 first-connexion-title">{{ $t('onboarding.valid.identity') }}</h1>
          <h1 class="page-title mt-4 ml-4 first-connexion-subtitle">{{ $t('onboarding.identity.unlock') }}</h1>
        </div>

        <img :class="{'margin-bottom-15':currentStep===4}" :src="require(`@/assets/images/b122/img-watcher-right.png`)"
             class="first-connexion-step-img">
      </div>
    </template>

    <div>
      <div v-if="currentStep === 1">
        <!-- Contenu pour l'étape 1 -->
        <h1 class="page-title">{{ $t('onboarding.annonce.title') }}</h1>
        <p class="first-connexion-text mt-2" v-html="$t('onboarding.annonce.text')"></p>
      </div>
      <div v-if="currentStep === 2">
        <!-- Contenu pour l'étape 2 -->
        <h1 class="page-title">{{ $t('onboarding.watcher.title') }}</h1>
        <p class="first-connexion-text mt-2" v-html="$t('onboarding.watcher.text')"></p>
      </div>

      <div v-if="currentStep === 3">
        <!-- Contenu pour l'étape 3 -->
        <h1 class="page-title">{{ $t('onboarding.lampion.title') }}</h1>
        <p class="first-connexion-text mt-2" v-html="$t('onboarding.lampion.text')"></p>
        <p class=" mt-2" v-html="$t('onboarding.lampion.text.info')"></p>
      </div>

      <div v-if="currentStep === 4">
        <!-- Contenu pour l'étape 4 -->
        <p class="first-connexion-text mt-2" v-html="$t('onboarding.need.identity')"></p>

        <b-form>
          <div class="row position-relative">
            <div class="col-md-12">
              <b-form-group
                :invalid-feedback="identity.recto.invalidFeedback"
                :label="$t('Recto')"
                class="mb-4"
                label-for="recto-input">
                <b-form-file
                  id="recto-input"
                  v-model="identity.recto.value"
                  :browse-text="$t('Select')"
                  :drop-placeholder="$t('drop-placeholder')"
                  :placeholder="identity.recto.value ? identity.recto.value.name : ''"
                  :state="identity.recto.state"
                  accept=".png, .jpeg, .jpg, .pdf"
                  required
                  v-on:change="removeInvalidFeedback('recto')">
                </b-form-file>
              </b-form-group>
              <b-form-group
                :invalid-feedback="identity.verso.invalidFeedback"
                :label="$t('Verso')"
                class="mb-4"
                label-for="verso-input">
                <b-form-file
                  id="verso-input"
                  v-model="identity.verso.value"
                  :browse-text="$t('Select')"
                  :drop-placeholder="$t('drop-placeholder')"
                  :placeholder="identity.verso.value ? identity.verso.value.name : ''"
                  :state="identity.verso.state"
                  accept=".png, .jpeg, .jpg, .pdf"
                  class="custom-file"
                  required
                  v-on:change="removeInvalidFeedback('verso')">
                </b-form-file>
              </b-form-group>

              <b-form-group
                :label="$t('onboarding.pass.identity')"
                class="mb-4 d-flex flex-row-reverse"
                label-for="passIdentity-input">
                <b-form-checkbox
                  id="passIdentity-input"
                  v-model="passIdentity">
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>
        </b-form>

        <p class="main-red-color text-uppercase" v-html="$t('onboarding.pass.identity.warning')"></p>

      </div>
      <div v-if="currentStep >=5">
        <!-- Contenu pour l'étape 5 -->
        <h1 class="page-title">{{ $t('onboarding.wait.validate.title') }}</h1>
        <p class="first-connexion-text mt-3" v-html="$t('onboarding.wait.validate.text')"></p>
      </div>
    </div>


    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button v-if="currentStep>1&&currentStep<4" class="w-100 mr-2" variant="secondary" @click="handleCancel()">
          <div class="d-flex justify-content-center">
            <i v-if="currentStep<4" class="ph-custom ph-caret-circle-left-bold mr-1 align-self-center"/><span
            class="align-self-center mt-small-px">{{ currentStep === 4 ? $t('Skip') : $t('Previous') }}</span>
          </div>
        </b-button>
        <b-button class="w-100" variant="primary" @click="handleOk($event)">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{ okButtonTitle }}</span> <i
            class="ph-custom ph-caret-circle-right-bold ml-1 align-self-center"/>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import api from "../../services/api";
import i18n from "../../i18n";

export default {
  data() {
    return {
      selectedReasonComponentName: null,
      currentStep: 1,
      needValidation: null,
      identity: {
        recto:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        verso:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
      },
      passIdentity: false,
    };
  },

  props: {
    isFirstConnexion: {
      default: null,
      required: true
    },
    reference: {
      default: "firstConnexionModal",
      required: false
    }
  },

  mounted() {
    this.fetchUserIdentityValidation()
    this.selectedReasonComponentName = localStorage.getItem('selectedReason')
    if (this.currentStep === 1 && this.isFirstConnexion) {
      this.requestNotificationPermission();
    }
    this.identity.recto.value = null
    this.identity.verso.value = null
  },

  watch: {
    '$store.getters.username': function (newValue, oldValue) {
      this.fetchUserIdentityValidation()
    },
  },

  computed: {
    okButtonTitle() {
      if (this.currentStep === 4) {
        return this.$t('Validate');
      } else if (this.currentStep === 3 && !this.needValidation) {
        return this.$t('Finish')
      } else if (this.currentStep >= 5) {
        return this.selectedReasonComponentName ? this.$t(`onboarding.${this.selectedReasonComponentName}.button`) : this.$t('Validate');
      } else {
        return this.$t('Next');
      }
    },

    cancelButtonTitle() {
      return this.currentStep === 1 ? this.$t('Cancel') : this.$t('Back');
    },
    totalSteps() {
      return 5;
    },
  },

  methods: {
    handleSubmit() {
      let data = new FormData()
      data.append('identityRectoFile', this.identity.recto.value)
      data.append('identityVersoFile', this.identity.verso.value)

      api({
        method: "POST",
        url: '/user/sendIdentity',
        data: data
      })
        .then((response) => {
          this.currentStep++
        })
        .catch(error => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.identity[invalidField]['state'] = false
            this.identity[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
          }
        })
    },

    handleOk(e) {
      e.preventDefault()
      if (this.currentStep === 4 && !this.passIdentity) {
        this.handleSubmit()
      } else if ((this.currentStep === 3 && !this.needValidation) || (this.currentStep === 4 && this.passIdentity)) {
        let data = new FormData()
        data.append('isFirstConnexion', false)
        api({
          method: "POST",
          url: '/user/updateFirstConnexion',
          data: data
        })
        this.$bvModal.hide('first-connexion-modal')
      } else if (this.currentStep >= 5) {
        if (this.selectedReasonComponentName) {
          this.$router.push({name: this.selectedReasonComponentName})
          localStorage.removeItem('selectedReason')
        }
        this.$bvModal.hide('first-connexion-modal')
      } else if (this.currentStep < this.totalSteps) {
        this.currentStep++;
        if (this.currentStep === 2) {
          this.requestGeolocationPermission();
        }
      }
    },

    resetModal() {
      this.currentStep = 1;
    },

    handleCancel() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },

    removeInvalidFeedback(field) {
      this.identity[field]['state'] = null
    },

    requestNotificationPermission() {
      if (!("Notification" in window)) {

      } else if (Notification.permission !== "denied") {
        Notification.requestPermission();
      }
    },

    requestGeolocationPermission() {
      navigator.geolocation.getCurrentPosition(
        function (position) {
        },
        function (error) {
        }
      );
    },

    fetchUserIdentityValidation() {
      if (this.$store.getters.isAuthenticated) {
        api
          .get(`/user/getCurrentUserValidation`)
          .then(response => {
            this.needValidation = response.data.needValidation
          })
      }
    }
  },
};
</script>

<!-- not scoped car modal -->
<style>
#first-connexion-modal .modal-content,
#first-connexion-modal .modal-header,
#first-connexion-modal .modal-body,
#first-connexion-modal .modal-footer {
  background-color: var(--main-black-dark);
}

.first-connexion-title {
  font-size: 34px !important;
}

.first-connexion-subtitle {
  font-size: 24px;
}

.first-connexion-step-img {
  max-width: 200px;
}

.first-connexion-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}

.first-connexion-bg-veilleur {
  flex-shrink: 0;
  border-radius: 95px;
  background-color: var(--main-black-medium);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.first-connexion-step-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

.first-connexion-text {
  color: var(--main-grey-medium);
}

.first-connexion-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}

.first-connexion-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

.custom-file-label::after {
  background-color: var(--main-black-light) !important;
  color: var(--main-text-color) !important;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

@media (min-width: 992px) {
  .first-connexion-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  .first-connexion-container img {
    order: 2;
    align-self: center;
  }

  .first-connexion-container {
    text-align: center;
  }
}

#first-connexion-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.margin-bottom-15 {
  margin-bottom: -15px;
}

.first-connexion-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}

.first-connexion-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #first-connexion-modal .modal-content {
    display: flex;
    overflow: auto;
  }

  #first-connexion-modal .first-connexion-header {
    margin-top: 0px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #first-connexion-modal .modal-body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #first-connexion-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #first-connexion-modal .modal-content {
    padding: 0;
    margin: 8px;
  }

  .first-connexion-header-content, .first-connexion-text, .first-connexion-container {
    padding: 10px;
  }

  .first-connexion-step-img {
    max-width: 100px;
  }
}

@media (max-height: 852px) {
  #first-connexion-modal .modal-content {
    overflow: auto;
  }

  .first-connexion-title {
    font-size: 24px !important;
  }

  .first-connexion-subtitle {
    font-size: 18px;
  }

  .first-connexion-header-content, .first-connexion-text, .first-connexion-container {
    padding: 0px;

  }
}

</style>



// WEBPACK FOOTER //
// src/views/user/FirstConnexionModal.vue